<template>
<div v-if='items.length'>
  <b-btn @click="filterLog = !filterLog" class='toggle-tags' variant="primary">
    <span v-if="filterLog">Show All Logs</span>
    <span v-else>Filer Logs</span>
  </b-btn>
  <b-list-group >
    <b-list-group-item v-for="(item, index) in items" :key="'item-'+ index">
        <div>
          <b bold>{{item['change_date']}}</b>
        </div>
        <div v-for="(key, i) in Object.keys(item['changes'])" :key="'item-'+ index + '-' + i">
          <b bold>{{key}}: </b>
          <span>{{item['changes'][key] || 'Null'}}</span>
        </div>
    </b-list-group-item>
  </b-list-group>
</div>
<div v-else>
  <h6>No history for this feature type at this given time</h6>
</div>
</template>

<script>
export default {
  name: 'info-log',
  data() {
    return {
      initData: [],
      filteredData: [],
      filterLog: true,
      filtetrKeys: ['parent_id', 'child_ids', 'target', 'source']
    }
  },
  computed: {
    feature() {
      return this.$store.getters['map/currentInfoItem']
    },
    items() {
      let v = this.filterLog ? this.filteredData : this.initData
      return v
    }
  },
  methods: {
    loadHistory(val) {
      if (val && val.id) {
        if (val['centreline_type']) {
          this.$http.get('/api/layers/centreline-history', {
              params: {
                id: val['id']
              }
            })
            .then(res => {
              this.initData
              this.extractData(res.body)
            }, res => {})
        }
        else if (val['well_type']) {
          this.$http.get('/api/layers/well-history', {
              params: {
                id: val['id']
              }
            })
            .then(res => {
              this.extractData(res.body)
            }, res => {})
        } else {
          this.items = []
        }
      }

    },
    extractData(data) {
      data = data.filter(d => d.changes && !d.changes.geo)

      data.forEach(d => {
        d['change_date'] =  new Date(d.change_date).toLocaleString()
        this.initData.push(d)
      })

      let filtered = []
      data.forEach(d => {
        d['filtered'] = true
        Object.keys(d.changes).forEach(k => {
          if (this.filtetrKeys.indexOf(k) > -1) {
            d['filtered'] = false
          }
        })
      })
      // filter out system entries
      data = data.filter(d => d['filtered'])
      // TODO: CLEAN
      for (i = 0; i < data.length; i++) {
        if (data[i+1]) {
          if (data[i]['change_date'] === data[i+1]['change_date']) {
            Object.keys(data[i+1].changes).forEach(k => {
              data[i].changes[k] = data[i+1].changes[k]
            })
            data.splice(i+1, 1)
            i = i - 1
          }
        }
      }
      for (i = 0; i < this.initData.length; i++) {
        if (this.initData[i+1]) {
          if (this.initData[i]['change_date'] === this.initData[i+1]['change_date']) {
            Object.keys(this.initData[i+1].changes).forEach(k => {
              this.initData[i].changes[k] = this.initData[i+1].changes[k]
            })
            this.initData.splice(i+1, 1)
            i = i - 1
          }
        }
      }
      this.filteredData = data
    }
  },
  watch: {
    feature(val) {
      if (val) {
        this.loadHistory(val)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/info/InfoChangeLog.vue